import ChartParametersFormattingStrategy from "./ChartParametersFormattingStrategy";
import DateRangeFormattingStrategy from '../../../parametersFormatting/DateRangeFormattingStrategy'

export default class OvertimeParametersFormattingStrategy extends ChartParametersFormattingStrategy {
    init({selectorsData, dateFormat, reportAuthorizationInfo}) {
        super.init({selectorsData, dateFormat, reportAuthorizationInfo})
        return this
    }

    createDateParametersFormattingStrategy(config) {
        return new DateRangeFormattingStrategy(config.dateFormat)
    }

    formatParametersText(selectedParameters) {
        return this.parametersFormatter.formatOvertimeUsersSelection(selectedParameters.hierarchicalSelectorsParameters.userSelection)
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/charts/parametersFormatters/OvertimeParametersFormattingStrategy.js